import React from "react";
import { ButtonContainer } from "../components/ButtonContainer";
import { RequestGroupedFolderMove } from "./RequestGroupedFolderMove";
import { CommandAuthorization, SharedDrive, SyncStatus } from "~/gql/types2";
import { GroupedFolder } from "../types";
import { CompleteGroupedFolderMove } from "./CompleteGroupedFolderMove";
import { OverrideGroupedFolderSync } from "./OverrideGroupedFolderSync";
import { Body1 } from "@material/react-typography";
import { IfAuthorized } from "~/components/IfAuthorized";

type GroupedFolderActionsProps = {
  folder: GroupedFolder;
  driveOptions: SharedDrive[];
};

export const GroupedFolderActions: React.FC<GroupedFolderActionsProps> = ({
  folder,
  driveOptions,
}) => {
  if (
    folder.syncStatus === SyncStatus.PendingMove &&
    folder.targetFolderPath != null
  ) {
    return (
      <IfAuthorized
        command={CommandAuthorization.CompleteGroupedFolderMoveCommand}
      >
        <ButtonContainer>
          <CompleteGroupedFolderMove folder={folder} />
        </ButtonContainer>
      </IfAuthorized>
    );
  }

  if ([SyncStatus.Error, SyncStatus.Unsynced].includes(folder.syncStatus)) {
    return (
      <>
        {folder.syncStatus === SyncStatus.Error && (
          <Body1>
            Sync error: {folder.syncErrorMessage ?? "Unhandled error"}
          </Body1>
        )}
        <IfAuthorized
          command={CommandAuthorization.OverrideGroupedFolderSyncCommand}
        >
          <OverrideGroupedFolderSync folder={folder} />
        </IfAuthorized>
      </>
    );
  }

  return (
    <IfAuthorized
      command={CommandAuthorization.RequestGroupedFolderMoveCommand}
    >
      <ButtonContainer>
        <RequestGroupedFolderMove folder={folder} driveOptions={driveOptions} />
      </ButtonContainer>
    </IfAuthorized>
  );
};
